// The code in this file will load on every page of your site
import { authentication, currentMember } from 'wix-members-frontend';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';
import { testReportOwner } from 'public/reportOwner.js';
import wixData from 'wix-data';
import { assignLabels } from 'backend/usersAPI';
import wixWindow from 'wix-window';
import { orders } from 'wix-pricing-plans';
import { getUserContactDetails } from 'backend/membership';
import wixWindowFrontend from 'wix-window-frontend';
import { recommendationScores } from 'public/recommendationScores.js';
import { session } from 'wix-storage-frontend';
import wixLocationFrontend from 'wix-location-frontend';
import { createAutomationCard } from 'public/createAutomationCard.js';
import { setInitialAMAClickObserver, openAMA } from 'public/amaHelper';
import { setContactLabel } from 'backend/userContact';
import { getSession } from 'backend/stripeModule';
import { getSession as getUserSession } from 'backend/usersAPI'
import { myRegisterMemberFunction } from 'backend/userContact';
// const CleverTap = require("clevertap");
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';
import { setInitialAMAObserver } from 'public/amaHelper1';
import { getCurrentMemberDetails } from 'backend/userProfile.jsw';
import { customLoginOrSignup, handleLoginSignupCTEvents } from 'public/customSignUpLogin';
import { handleDonateBtnLink, handleUpgradeMembershipBtn } from 'public/manageHeader';
import { footerBtnClicks } from 'public/manageFooter';

export let previousPageURL = session.getItem("page");

import {
    labelScoresForErica,
    getThreadId,
    sendMessageAndGetResponse
} from 'backend/ama';

export let isLoading = false;
let isLoginPopupShown = false;
let aboutDropdownTimeout = null;
const becomeMemberBtnHeader = $w("#memberBtnHeader");
const becomeMemberBtnMobileBx = $w("#becomeMemberBtnMobileBx");
let userIsActiveCoach = false;
let referrer = wixWindowFrontend.referrer;
const currentUrl = wixLocationFrontend.url;
let isAboutDropdownShown = false;

export function headerDropdown_click() {
    if (isAboutDropdownShown) {
        $w("#dropdownBx").collapse();
        isAboutDropdownShown = false;
    } else {
        $w("#dropdownBx").expand();
        isAboutDropdownShown = true;
    }
}

export function headerDropdown_mouseOut() {
    aboutDropdownTimeout = setTimeout(() => {
        $w("#dropdownBx").collapse();
        isAboutDropdownShown = false;
    }, 1300);
}

export function headerDropdown_mouseIn(event) {
    clearTimeout(aboutDropdownTimeout);
}

wixUsers.onLogin((member) => {

    //21-May-2025 setCTProfile();
    handleLoginSignupCTEvents();
    console.log('wixUsers.onLogin....');

    orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
        .then((ordersList) => {
            console.log("plans..1", ordersList);
            currentMember.getMember({ fieldsets: ['FULL'] })
                .then((member) => {
                    console.log('member..1', member);
                    let propertiesForCT = {
                        "name": member.profile.nickname,
                        "firstName": member.contactDetails.firstName,
                        "lastName": member.contactDetails.lastName,
                        "Identity": member._id,
                        "Email": member.loginEmail
                    };
                    ordersList.forEach((plan) => {
                        if (!['Donation', 'App Paid Membership', 'App Lifetime Membership'].includes(plan.planName) && !plan.cancellation) {
                            propertiesForCT[plan.planName] = plan.status
                        }
                    })
                    //21-May-2025 saveCleverTapEvent('onUserLogin', propertiesForCT);
                })
                .catch((error) => {
                    console.error(error);
                });
        })

    $w("#loginRegisterBx").collapse();
    $w("#loginRegisterBxMobile").collapse();
    //$w("#starIcon").collapse();
    //$w("#mobileStarIcon").collapse();
    $w("#membersLoginBar8").expand();

    // saveCleverTapEvent('onUserLogin', '{ "Site": { "Name": "Jack Montana",  "Identity": 61026032,   "Email": "jack@gmail.com",  "Phone": "+14155551234", "Gender": "M",  "DOB": ""  }');

    // $w("#button173").enable();
    $w("#quizzJourneyMobile").label = `My Journey`;

    //$w("#quizzJourneyMobile").link = `https://www.talenttransformation.com/account/my-journey`;
    //$w("#quizzesJourney").html = `<p class="font_7"><a href="https://www.talenttransformation.com/account/my-journey" target="_self">My Journey</a></p>`;

    $w("#quizzJourneyMobile").link = `https://www.talenttransformation.com/my-journey`;
    $w("#quizzesJourney").html = `<p class="font_7"><a href="https://www.talenttransformation.com/my-journey" target="_self">My Journey</a></p>`;

    checkUserOrder();

    //21-May-2025 checkIfSubscriberIsSet("master");

    if (wixLocation.url.includes("/plans-pricing/status/")) {
        console.log("in pricing PLan Status #######");

        orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
            .then((ordersList) => {
                console.log("plans ", ordersList);

                currentMember.getMember({ fieldsets: ['FULL'] })
                    .then((member) => {
                        console.log('member..2', member);
                        let propertiesForCT = { "name": member.profile.nickname, "firstName": member.contactDetails.firstName, "lastName": member.contactDetails.lastName, "Identity": member._id, "Email": member.loginEmail };
                        ordersList.forEach((plan) => {
                            // if (plan.planName != `Donation` && !plan.cancellation && plan.planName != `App Paid Membership` && plan.planName != `App Lifetime Membership`) {
                            //     propertiesForCT[plan.planName] = plan.status
                            // }
                            if (!['Donation', 'App Paid Membership', 'App Lifetime Membership'].includes(plan.planName) && !plan.cancellation) {
                                propertiesForCT[plan.planName] = plan.status
                            }
                        })
                        //21-May-2025 saveCleverTapEvent('onUserLogin', propertiesForCT);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            })

    }
    if (wixLocation.url.includes("full/")) {
        testReportOwner($w("#dynamicDataset").getCurrentItem());
    }

    handleUpgradeMembershipBtn(); // Header upgrade membership btn

});

/* 21-May-2025
function setCTProfile() {
    const isLoggedIn = authentication.loggedIn();
    if (isLoggedIn) {
        const ctLoggedInWith = session.getItem("ctLoggedInWith");
        const ctSubscribedToNewsletter = session.getItem("isMailSubscribed");
        if (ctLoggedInWith) {
            currentMember.getMember()
                .then((member) => { //member._id,
                console.log('member..3', member);
                    let propertiesForCT = {
                        "name": member.profile.nickname,
                        "firstName": member.contactDetails.firstName,
                        "lastName": member.contactDetails.lastName,
                        "Identity": member._id,
                        "Email": member.loginEmail
                    };
                    propertiesForCT[ctLoggedInWith] = "true";
                    let propertiesForCTSignUp = {
                        "MarketingSourceAttribution": referrer,
                        "WixUserId": member._id,
                        "Email": member.loginEmail
                    };
                    propertiesForCTSignUp[ctLoggedInWith] = "true";
                    if (ctSubscribedToNewsletter == "true") {
                        propertiesForCT["SubscribedToNewsletter"] = "true";
                        propertiesForCTSignUp["SubscribedToNewsletter"] = "true";
                    } else {
                        propertiesForCT["SubscribedToNewsletter"] = "false";
                        propertiesForCTSignUp["SubscribedToNewsletter"] = "false";
                    }
                    if (["SignupWithEmail", "LoginWithGmail", "LoginWithFacebook", "LoginWithLinkedIn", "LoginWithEmail"].includes(ctLoggedInWith)) {
                        socialSignUpEvent(propertiesForCTSignUp);
                    }
                    saveCleverTapEvent("onUserLogin", propertiesForCT);
                    setTimeout(() => {
                        session.removeItem("ctLoggedInWith");
                    }, 30000)
                })
        }
    }
}

async function socialSignUpEvent(propertiesForCT) {
    const member = await currentMember.getMember();
    console.log('member..4', member);
    const createdTime = new Date(member._createdDate).getTime()
    const createdBeforeSec = Math.floor((Date.now() - createdTime) / 1000);
    console.log(`User was created befor ${createdBeforeSec} seconds`);
    if(createdBeforeSec < 60){
        console.log('user signed up');
        propertiesForCT.UtmSource = session.getItem("utmSource") ?? "unknown";
        propertiesForCT.UtmMedium = session.getItem("utmMedium") ?? "unknown";
        propertiesForCT.UtmCampaign = session.getItem("utmCampaign") ?? "unknown";
        saveCleverTapEvent("User Signed up", propertiesForCT);
    } else {
        console.log('user signed in');
    }

}
21-May-2025 */

$w.onReady(function () {
    // const clevertap = CleverTap.init("8W8-K47-4W7Z", "SCE-RAX-ASEL", CleverTap.REGIONS.EUROPE);

    const isLoggedIn = authentication.loggedIn();
    let query = wixLocation.query;
    wixLocationFrontend.queryParams.remove(['session_id']);

    //21-May-2025 setCTProfile();
    if (isLoggedIn) {
        handleLoginSignupCTEvents();
    }
    console.log('isLoggedIn....', isLoggedIn);

    session.setItem("page", wixLocation.url);

    if (query.guestSignup === "yes" && !wixUsers.currentUser.loggedIn && !wixLocation.url.includes("assessments/")) {
        wixWindowFrontend.openLightbox("Guest Sign Up")
            .then((rData) => {
                if (rData.toOpen === "signUpForm") {
                    /*21-May-2025
                     wixWindowFrontend.openLightbox('SIGN UP', {
                            value: "signup",
                        })
                        .then((receivedData) => {
                            if (receivedData.userEmail) {
                                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                            }
                        }) 
                        21-May-2025 */
                    customLoginOrSignup('signup');
                }
            })
    }

    if (query.signup == "yes" && !wixUsers.currentUser.loggedIn) {
        /* 21-May-2025
         wixWindowFrontend.openLightbox('SIGN UP', {
                value: "signup",
            })
            .then((receivedData) => {
                if (receivedData.userEmail) {
                    $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                }
            })
            21-May-2025 */
        customLoginOrSignup('signup');
    }

    if (wixUsers.currentUser.loggedIn) {
        $w("#loginRegisterBx").collapse();
        $w("#loginRegisterBxMobile").collapse();
        $w("#membersLoginBar8").expand();
        $w("#quizzJourneyMobile").label = `My Journey`;

        //$w("#quizzJourneyMobile").link = `https://www.talenttransformation.com/account/my-journey`;
        //$w("#quizzesJourney").html = `<p class="font_7"><a href="https://www.talenttransformation.com/account/my-journey" target="_self">My Journey</a></p>`;

        $w("#quizzJourneyMobile").link = `https://www.talenttransformation.com/my-journey`;
        $w("#quizzesJourney").html = `<p class="font_7"><a href="https://www.talenttransformation.com/my-journey" target="_self">My Journey</a></p>`;

        checkUserOrder();
        //21-May-2025 checkIfSubscriberIsSet("master");

        handleUpgradeMembershipBtn(); // Header upgrade membership btn

    } else {
        $w("#loginRegisterBx").expand();
        $w("#loginRegisterBxMobile").expand();
        $w("#membersLoginBar8").collapse();
        $w("#quizzJourneyMobile").label = `Helpful Quizzes`;

        //$w("#quizzJourneyMobile").link = `https://www.talenttransformation.com/quizzes`;
        //$w("#quizzesJourney").html = `<p class="font_7"><a href="https://www.talenttransformation.com/quizzes" target="_self">Helpful Quizzes</a></p>`;

        $w("#quizzJourneyMobile").link = `https://www.talenttransformation.com/my-journey`;
        $w("#quizzesJourney").html = `<p class="font_7"><a href="https://www.talenttransformation.com/my-journey" target="_self">Helpful Quizzes</a></p>`;

        if (!wixLocation.url.includes("assessments")) {
            becomeMemberBtnHeader.expand();
            becomeMemberBtnMobileBx.expand();
        }

        /* new changes starts*/
        becomeMemberBtnHeader.expand();
        becomeMemberBtnHeader.label = `Donate`;
        becomeMemberBtnHeader.link = `https://www.talenttransformation.com/donate`;
        becomeMemberBtnHeader.target = "_self";

        $w("#membershipHead").text = `Donate`;
        $w("#membershipPara").collapse();
        /* new changes ends*/

    }

    if (wixLocation.url.toString().includes(`helpful-resources`) || wixLocation.url.toString().includes(`helpful-resource`) || wixLocation.url.toString().includes(`post/`)) {
        $w("#resourcesActiveLine").expand();
    } else {
        $w("#resourcesActiveLine").collapse();
    }

    if (wixLocation.url.toString().includes(`my-journey`) || wixLocation.url.toString().includes(`quizzes`)) {
        $w("#quizzessJourneyActiveLine").expand();
    } else {
        $w("#quizzessJourneyActiveLine").collapse();
    }

    if (wixLocation.url.toString().includes(`/coaches`)) {
        $w("#coachesActiveLine").expand();
    } else {
        $w("#coachesActiveLine").collapse();
    }

    //showLoader();
    // console.log('ready')

    //wixWindow.openLightbox("subscribe");

    if (query.subscribe == "yes") {
        wixWindowFrontend.openLightbox("Subscribe");
    }

    if (wixLocation.url.includes("full/")) {
        $w("#dynamicDataset").onReady(() => {
            let item = $w("#dynamicDataset").getCurrentItem();
            testReportOwner(item);
            let diference = Date.now() - item._createdDate;
            // createAutomationCard(wixLocation.url, wixUsers.currentUser.id, "d8aa70e9-3a57-4ab5-9b01-2bfcb36d3c19");
            if (diference < 180000 && !wixLocation.query.shareMyReport) {
                createAutomationCard(wixLocation.url, wixUsers.currentUser.id, "d8aa70e9-3a57-4ab5-9b01-2bfcb36d3c19");
            }
        })
    }
    if (query.minimal == "false") {
        session.setItem("minimalNavigation", "false");
    }
    if (query.minimal == "yes" || session.getItem("minimalNavigation") == "true") {
        $w("#header2").collapse();
        try { $w("#askEricaMain").collapse(); } catch {
            console.log("no Erica")
        }
        $w("#section189").collapse();
        session.setItem("minimalNavigation", "true");

        //Hide donation section in app from report page
        if (wixLocation.url.includes("full/")) {
            $w("#donateBx").collapse();
        }
    }

    if (query.token) {
        console.log("it contains token");
        console.log(query.token);
        //session.setItem("ctLoggedInWith", "LoginWithFacebook");
        setTimeout(() => {

            authentication.applySessionToken(query.token)
                .then(() => {
                    // console.log('Member logged in via facebook...');
                    if (session.getItem("isMailSubscribed") == 'true') {
                        currentMember.getMember()
                            .then((member) => {
                                console.log('member..5', member);
                                const memberContactId = member.contactId;
                                setContactLabel(memberContactId, ["custom.subscriber"])
                                    .then((data) => {
                                        console.log('Subscriber label added')
                                    })
                                    .catch((err) => {
                                        console.log("Subscriber label failed", err);
                                    })
                            })
                    }
                    // $w("#mainTitle").text = "logged";
                    $w("#dynamicDataset").onReady(() => {

                        let item = $w("#dynamicDataset").getCurrentItem();
                        testReportOwner(item);

                    })
                });
        }, 1000);
    }

    // Write your code here
    setTimeout(function () {
        hideLoader();
    }, 1000);

    if (wixLocation.url.includes("plans-pricing")) {
        hideMembershipBtn();
    }
    //console.log("setAMA")
    setInitialAMAObserver();

    console.log("reached erica preparation background")
    prepareEricaInBackground();

    handleDonateBtnLink(); // Header donate btn
    headerMenuClickHandler(); // Header Menu click handler
    footerBtnClicks(); // Handles footer subscribe btn

});

// Function for your master script
function prepareEricaInBackground() {
    try {
        // Check if we've recently prepared Erica
        const lastPrepTime = session.getItem("ericaLastPrepTime");
        const currentTime = Date.now();

        // Only prepare if it hasn't been prepared in the last hour
        if (lastPrepTime && (currentTime - parseInt(lastPrepTime) < 3600000)) {
            return; // Skip preparation if done recently
        }

        // Step 1: Check if thread exists or create one
        let threadId = session.getItem("threadId");
        if (!threadId) {
            // Get a new thread and store it in session
            getThreadId().then(newThreadId => {
                session.setItem("threadId", newThreadId);
                runPreparationWithThread(newThreadId);
            });
        } else {
            // We already have a thread, run preparation with existing thread
            runPreparationWithThread(threadId);
        }
    } catch (error) {
        console.error("Error in Erica background preparation:", error);
    }
}

// Helper function to run preparation with a given thread ID
function runPreparationWithThread(threadId) {
    const isLoggedIn = authentication.loggedIn();
    const mode = "web";
    const caller = "backgroundPrep";

    // This follows the exact same sequence as your checkQuizzes function
    const prepareUser = async () => {
        try {
            let message;

            if (isLoggedIn) {
                const userEmail = await wixUsers.currentUser.getEmail();
                message = await labelScoresForErica(userEmail, mode, caller);
            } else {
                message = await labelScoresForErica("", mode, caller);
            }

            console.log("erica preparation background message:", message)

            // Send message using backend function
            await sendMessageAndGetResponse(threadId, message);

            // Save timestamp of this preparation
            session.setItem("ericaLastPrepTime", Date.now().toString());

            // NEW: Set a flag that lightbox can check to skip preparation
            session.setItem("ericaPreparationComplete", "true");

            console.log("Erica background preparation completed successfully");
        } catch (error) {
            console.error("Error in Erica preparation:", error);
            // Important: Clear the flag on error so lightbox will try again
            session.setItem("ericaPreparationComplete", "false");
        }
    };

    // Run the preparation
    prepareUser();
}

export function checkIfSubscriberIsSet(source) {
    // console.log("wow inside the func")
    currentMember.getMember({ fieldsets: ['FULL'] })
        .then((memberData) => {
            console.log('member..6', memberData);
            const contactID = memberData.contactId;
            const loginEmail = memberData.loginEmail;

            if (source === "master") {
                getUserContactDetails(contactID)
                    .then((userContactDetails) => {
                        let hasSubscriberLabel = false;
                        let isSubscriberTagSet = false;
                        const allLabels = userContactDetails.info.labelKeys;
                        const allTags = userContactDetails.info.extendedFields;

                        // console.log("wow sign up userContactDetails", userContactDetails);
                        // console.log("wow sign up allLabels", allLabels);
                        // console.log("wow sign up allTags", allTags);

                        if (allLabels) {
                            allLabels.forEach((label) => {
                                if (label == `custom.subscriber`) {
                                    hasSubscriberLabel = true;
                                }
                            });
                        }

                        if (!hasSubscriberLabel) {
                            return;
                        }

                        for (const key in allTags) {
                            if (key == `emailSubscriptions.subscriptionStatus` && allTags[key] != `NOT_SET`) {
                                isSubscriberTagSet = true;
                            }
                        }

                        if (hasSubscriberLabel && !isSubscriberTagSet) {
                            $w("#hiddenSubscribeEmailInput").value = loginEmail;
                            // console.log("wow hidden field master", $w("#hiddenSubscribeEmailInput"));
                        }
                    })
            } else if (source === "signUp") {
                $w("#hiddenSubscribeEmailInput").value = loginEmail;
                // console.log("wow hidden field signUp", loginEmail, $w("#hiddenSubscribeEmailInput"));
            }
        })
}

function hideMembershipBtn() {
    becomeMemberBtnHeader.collapse();
    becomeMemberBtnMobileBx.collapse();
}

function checkUserOrder() {
    orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
        .then((ordersList) => {
            // console.log("wowww", ordersList);
            let allActivePlans = [];
            let allActivePaidPlans = [];
            let allActiveFreePlans = [];

            if (ordersList && ordersList.length != 0) {
                ordersList.forEach((order) => {
                    if (order.planName != `Donation` && !order.cancellation) {
                        allActivePlans.push(order);
                    }
                });
            }

            if (allActivePlans && allActivePlans.length != 0) {
                checkIfCoach()
                    .then((isActiveCoach) => {
                        let isSponsoredMember = false;
                        let isSupportingMember = false;

                        if (isActiveCoach) {
                            userIsActiveCoach = true;
                        }

                        allActivePlans.forEach((order) => {
                            if (order.planName.toLowerCase().includes("sponsoring")) {
                                isSponsoredMember = true;
                            } else if (order.planName.toLowerCase().includes("supporting")) {
                                isSupportingMember = true;
                            }

                            if (isSponsoredMember) {
                                becomeMemberBtnHeader.collapse();
                                becomeMemberBtnMobileBx.collapse();
                            } else if (!isActiveCoach && isSupportingMember) {
                                becomeMemberBtnHeader.collapse();
                                becomeMemberBtnMobileBx.collapse();
                            } else {
                                becomeMemberBtnHeader.label = `Upgrade Membership`;
                                $w("#membershipHead").text = `Upgrade Membership`;
                                $w("#membershipPara").collapse();

                                if (!wixLocation.url.includes("assessments")) {
                                    becomeMemberBtnHeader.expand();
                                    becomeMemberBtnMobileBx.expand();
                                }
                            }
                        })

                        if (wixLocation.url.includes("plans-pricing")) {
                            hideMembershipBtn();
                        }
                    });
            } else {
                becomeMemberBtnHeader.label = `Upgrade Membership`;
                $w("#membershipHead").text = `Upgrade Membership`;
                $w("#membershipPara").collapse();

                if (!wixLocation.url.includes("assessments")) {
                    becomeMemberBtnHeader.expand();
                    becomeMemberBtnMobileBx.expand();
                }
            }

            if (wixLocation.url.includes("plans-pricing")) {
                hideMembershipBtn();
            }

            if (currentUrl.includes("full/") || currentUrl.includes("post/") || currentUrl.includes("/makeanimpact")) {

                if (ordersList && ordersList.length != 0) {
                    ordersList.forEach((order) => {
                        if (order.planName != "Donation" && !order.cancellation && order.planName != "Free Member" && order.planName != "Free Coach Member") {
                            allActivePaidPlans.push(order)
                        }
                    })
                }

                $w("#memberBtn").label = "Upgrade Your Membership!";
                $w("#memberTitle").text = "Upgrade Membership";
                $w("#memberDesc").text = "Upgrade for an ad-free experience and exclusive features and resources. You'll gain valuable insights and support our initiative to help everyone succeed.";

                if (allActivePaidPlans && allActivePaidPlans.length != 0) {
                    $w("#memberBx").collapse();
                    $w("#donateTitle").text = "We appreciate your support!";
                }

                //$w('#donateBtn').link = "https://www.talenttransformation.com/donate";
                setDonationBtnLink();

                checkIfCoach()
                    .then((isActiveCoach) => {
                        if (isActiveCoach) {
                            $w("#memberBtn").target = "_blank";
                            $w("#memberBtn").link = "https://www.talenttransformation.com/membership-for-coaches";
                            setMembershipBtnLinkForActiveCoach();
                        } else {
                            $w("#memberBtn").target = "_blank";
                            $w("#memberBtn").link = "https://www.talenttransformation.com/monthly-membership";
                            setMembershipBtnLink();
                        }
                    })
            } else if (currentUrl.includes("/about-us")) {
                if (ordersList && ordersList.length != 0) {
                    ordersList.forEach((order) => {
                        if (order.planName != "Donation" && !order.cancellation && order.planName != "Free Member" && order.planName != "Free Coach Member") {
                            allActivePaidPlans.push(order)
                        }
                    })
                }

                $w("#memberBtn1").label = "Upgrade Your Membership!";
                $w("#memberBtn2").label = "Upgrade Your Membership!";
                $w("#memberTitle1").text = "Upgrade Membership";
                $w("#memberTitle2").text = "Upgrade Membership";
                $w("#memberDesc1").text = "Upgrade for an ad-free experience and exclusive features and resources. You'll gain valuable insights and support our initiative to help everyone succeed.";
                $w("#memberDesc2").text = "Upgrade for an ad-free experience and exclusive features and resources. You'll gain valuable insights and support our initiative to help everyone succeed.";

                if (allActivePaidPlans && allActivePaidPlans.length != 0) {
                    $w("#memberBx1").collapse();
                    $w("#memberBx2").collapse();
                    $w("#donateTitle1").text = "We appreciate your support!";
                    $w("#donateTitle2").text = "We appreciate your support!";
                }

                checkIfCoach()
                    .then((isActiveCoach) => {
                        if (isActiveCoach) {
                            $w("#memberBtn1").target = "_blank";
                            $w("#memberBtn1").link = "https://www.talenttransformation.com/membership-for-coaches";
                            $w("#memberBtn2").target = "_blank";
                            $w("#memberBtn2").link = "https://www.talenttransformation.com/membership-for-coaches";

                        } else {
                            $w("#memberBtn1").target = "_blank";
                            $w("#memberBtn1").link = "https://www.talenttransformation.com/monthly-membership";
                            $w("#memberBtn2").target = "_blank";
                            $w("#memberBtn2").link = "https://www.talenttransformation.com/monthly-membership";
                        }
                    })
            }
        })
        .catch((err) => {
            console.error(err);
        })

    checkIfCoach()
        .then((isActiveCoach) => {
            if (isActiveCoach) {
                userIsActiveCoach = true;
                $w("#memberBtnHeader").link = "https://www.talenttransformation.com/membership-for-coaches";
            }
        })
}

export function checkIfCoach() {
    return currentMember.getMember({ fieldsets: ['FULL'] })
        .then((member) => {
            console.log('member..7', member);
            //const allEmails = member.contactDetails.emails;
            const allEmails = member.loginEmail;
            //console.log('member allEmails:', allEmails);
            return wixData
                .query("Team1")
                .limit(1000)
                //.hasSome("ownerEmail", [...allEmails])
                .hasSome("ownerEmail", allEmails)
                .and(wixData.query("Team1").eq("active", true))
                .find()
                .then((data) => {
                    //console.log('data:-', data);
                    if (data.items && data.items.length != 0) {
                        return true;
                    } else {
                        return false;
                    }
                })
        })
        .catch((error) => {
            console.error(error);
        });
}

export function myJourneyLoaderShow() {
    $w('#preloader').expand();
}

export function myJourneyLoaderHide() {
    $w('#preloader').collapse();
}

export function subscriptionLoaderShow() {
    $w('#preloader').expand();
}

export function subscriptionLoaderHide() {
    $w('#preloader').collapse();
}

export function customLoaderShow() {
    $w('#preloader').expand();
    console.log("wow loader triggered!")
}

export function customLoaderHide() {
    $w('#preloader').collapse();
}

export function text247_click(event) {
    console.log("click247")
    /*21-May-2025
     authentication.promptLogin({ mode: 'login', modal: true })
        .then(() => {
            console.log('Member is logged in');
            $w("#text247").hide();
        })
        .catch((error) => {
            console.error(error);
        }); 
        21-May-2025 */
    customLoginOrSignup('login');
}

export function text248_click(event) {
    console.log("logout")
    authentication.logout()
    $w("#text247").show();
}

export function button148_click(event) {
    console.log(event.target);
    if (wixUsers.currentUser.loggedIn) { // if the user is logged in
        //wixLocation.to("/account/my-journey")
        wixLocation.to("/my-journey")
    } else {
        //wixLocation.to("/quizzes")
        wixLocation.to("/my-journey")
    }
}

export function button148_viewportEnter(event) {
    console.log("view")
    if (wixUsers.currentUser.loggedIn) { // if the user is logged in
        event.target.label = "My Journey";
    } else {
        event.target.label = "Helpful Quizzes";
    }
}

export function button150_click(event) {
    console.log("150")
    if (wixUsers.currentUser.loggedIn) { // if the user is logged in
        //wixLocation.to("/account/my-journey")
        wixLocation.to("/my-journey")
    } else {
        //wixLocation.to("/quizzes")
        wixLocation.to("/my-journey")
    }
}

export function button150_viewportEnter(event) {
    console.log("view150")
    if (wixUsers.currentUser.loggedIn) { // if the user is logged in
        event.target.label = "My Journey";
    } else {
        event.target.label = "Helpful Quizzes";
    }
}

export function showLoader(disableScroll = false) {
    $w("#preloader").expand();
}

export function hideLoader() {
    $w("#preloader").collapse();
}

/*export function showsignumodal_viewportEnter(event) {
    console.log('wow viewport entereted...');
    let query = wixLocation.query;
    if (!wixUsers.currentUser.loggedIn && !isLoading && !isLoginPopupShown && query.minimal !== "yes") {
        wixWindowFrontend.openLightbox("Guest Sign Up")
            .then((rData) => {
                isLoginPopupShown = true;
                if (rData.toOpen === "signUpForm") {
                    wixWindowFrontend.openLightbox('SIGN UP', {
                            value: "signup",
                        })
                        .then((receivedData) => {
                            if (receivedData.userEmail) {
                                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                            }
                        })
                }
            })
    }
}*/

export function imageX113_click(event) {
    showLoader();
}

export function becomeMemberBtnMobile_click(event) {
    if (!wixUsers.currentUser.loggedIn) {
        wixLocation.to("/donate");
    } else {
        if (userIsActiveCoach) {
            wixLocation.to("/membership-for-coaches");
        } else {
            wixLocation.to("/monthly-membership");
        }
    }
}

export function memberBtnHeader_click(event) {
    if (!wixUsers.currentUser.loggedIn) {
        wixLocation.to("/donate");
    } else {
        if (userIsActiveCoach) {
            wixLocation.to("/membership-for-coaches");
        } else {
            wixLocation.to("/monthly-membership");
        }
    }
}

export function headerLoginBtn_click(event) {
    /* 21-May-2025
    wixWindowFrontend.openLightbox('SIGN UP', {
            value: "login",
        })
        .then((receivedData) => {
            if (receivedData.userEmail) {
                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
            }
        }) 
        21-May-2025 */

    customLoginOrSignup('login');
}

export function headerRegisterBtn_click(event) {
    /* 21-May-2025
     wixWindowFrontend.openLightbox('SIGN UP', {
            value: "signup",
        })
        .then((receivedData) => {
            if (receivedData.userEmail) {
                console.log("reistered");
                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
            }
        })
        21-May-2025 */
    customLoginOrSignup('signup');
}

export function mobileLoginBtn_click(event) {
    /* 21-May-2025 
    wixWindowFrontend.openLightbox('SIGN UP', {
            value: "login",
        })
        .then((receivedData) => {
            if (receivedData.userEmail) {
                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
            }
        }) 
        21-May-2025 */
    customLoginOrSignup('login');
}

export function mobileRegisterBtn_click(event) {
    /* 21-May-2025 
    wixWindowFrontend.openLightbox('SIGN UP', {
            value: "signup",
        })
        .then((receivedData) => {
            if (receivedData.userEmail) {
                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
            }
        }) 
        21-May-2025 */
    customLoginOrSignup('signup');
}

export function horizontalMenu1_itemClick(event) {
    console.log('click item');
}

async function setDonationBtnLink() {
    if (wixLocationFrontend.query.minimal == "yes") {
        const loginSessionToken = await getLoginSessionToken();
        $w("#donateBtn").target = "_blank";
        $w('#donateBtn').link = `https://www.talenttransformation.com/donate?token=${encodeURIComponent(loginSessionToken)}`;
    }
}

async function setMembershipBtnLinkForActiveCoach() {
    if (wixLocationFrontend.query.minimal == "yes") {
        const loginSessionToken = await getLoginSessionToken();
        $w("#memberBtn").target = "_blank";
        $w("#memberBtn").link = `https://www.talenttransformation.com/membership-for-coaches?token=${encodeURIComponent(loginSessionToken)}`;
    }
}

async function setMembershipBtnLink() {
    if (wixLocationFrontend.query.minimal == "yes") {
        const loginSessionToken = await getLoginSessionToken();
        $w("#memberBtn").target = "_blank";
        $w("#memberBtn").link = `https://www.talenttransformation.com/monthly-membership?token=${encodeURIComponent(loginSessionToken)}`;
    }
}

export async function getLoginSessionToken() {
    return new Promise((resolve) => {
        let currentUser = wixUsers.currentUser;
        if (currentUser && currentUser.loggedIn) {
            currentUser.getEmail().then(emailForSession => {
                getUserSession(emailForSession).then(loginSessionToken => {
                    //console.log('loginSessionToken', loginSessionToken);
                    resolve(loginSessionToken);
                }).catch(err => {
                    console.log("er1:-", err)
                    resolve("");
                })
            }).catch(err => {
                console.log("er2:-", err)
                resolve("");
            });
        } else {
            resolve("");
        }
    })
}

function headerMenuClickHandler() {
    $w('#quizzesJourney').onClick((event) => {
        wixLocation.to('/my-journey');
    });
    $w('#helpfulResourcesMenu').onClick((event) => {
        wixLocation.to('/helpful-resources');
    });
    $w('#coachesMenu').onClick((event) => {
        wixLocation.to('/coaches');
    });
}

// console.log("end of master file")

export function subscriberEmailSubmitted() {
    /* 21-May-2025
    let propertiesForCT = { "MSG-email": true };
    saveCleverTapEvent('profile', propertiesForCT);
    // $w("#hiddenSubscribeEmailInput").value = "";
    orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
        .then((ordersList) => {
            console.log("plans ", ordersList);
            currentMember.getMember({ fieldsets: ['FULL'] })
                .then((member) => {
                    console.log('member..8', member);
                    let propertiesForCT = { "name": member.profile.nickname, "firstName": member.contactDetails.firstName, "lastName": member.contactDetails.lastName, "Identity": member._id, "Email": member.loginEmail };
                    ordersList.forEach((plan) => {
                        // if (plan.planName != `Donation` && !plan.cancellation && plan.planName != `App Paid Membership` && plan.planName != `App Lifetime Membership`) {
                        //     propertiesForCT[plan.planName] = plan.status
                        // }
                        if (!['Donation', 'App Paid Membership', 'App Lifetime Membership'].includes(plan.planName) && !plan.cancellation) {
                            propertiesForCT[plan.planName] = plan.status
                        }
                    })
                    saveCleverTapEvent('onUserLogin', propertiesForCT);
                    if( wixLocationFrontend.url.indexOf("redirect") > -1 ){
                        setInterval(()=> { saveCleverTapEvent('userSubscribed', {}) }, 1000);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        })
    console.log("subscribbed to email");
    21-May-2025 */
}